import EnvironmentConfiguration from "../../types/EnvironmentConfiguration";
import ApiRequestPaths from "../../constants/ApiRequestPaths";
import { ReservationRequestWithDistance } from "../../steps/Scheduling/hooks/useCreateReservation";
import { CachedSession } from "../../types/ISession";

/** Attempt to load the held reservation from the browser cache, and if successful then release it.
 * @remarks Can't use useApi or axios here since this function is intended to execute all actions in a single
 * execution instance.
 */
export const singleProcessReleaseReservation = () => {
  try {
    const { reservation, token, contactId, patient } = new CachedSession();

    if (reservation) {
      const requestInit: RequestInit = {
        keepalive: true,
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token.token}` },
        body: JSON.stringify(
          new ReservationRequestWithDistance(reservation.slot, undefined, reservation.center.distance)
        )
      };
      window
        .fetch(
          `${EnvironmentConfiguration.aspireBaseUrl}/${ApiRequestPaths.postReservationUrlV1_1(
            contactId,
            patient?.id,
            reservation.center.id,
            reservation.service.id,
            reservation.slot.id
          )}`,
          requestInit
        )
        .catch(() => {
          // NOOP
        });
    }
  } catch {
    // NOOP
  }
};

export default singleProcessReleaseReservation;
